/**
 * Updates the visibility of questions based on the show/hide property.
 *
 * @param {Object} idMap - A mapping of question IDs.
 * @param {Array} options - An array of options to update (show or hide).
 */
const updateQuestionVisibility = (idMap, options) => {
  if (Array.isArray(options) && options.length > 0) {
    const updatedOptions = options
      .map((option) => idMap[option])
      .filter((option) => option !== undefined)

    options.length = 0
    options.push(...updatedOptions)
  }
}

/**
 * Process the questionnaire using @processShowHideOption hook
 *
 * @param questions in questionnaire
 * @returns processed questionnaire
 */
const processQuestionnaire = (questions) => {
  let toProcess = JSON.parse(JSON.stringify(questions))
  let idMap = {}
  let count = 0
  // idMap generation
  for (let i = 0; i < questions.length; i++) {
    if (questions[i].type === 'raw') {
      count++
      idMap = { ...idMap, [questions[i].id]: undefined }
      toProcess[i].id = undefined
    } else {
      idMap = { ...idMap, [questions[i].id]: `v${i + 1 - count}` }
      toProcess[i].id = `v${i + 1 - count}`
    }
  }
  for (let i = 0; i < toProcess.length; i++) {
    if (toProcess[i].options !== undefined && toProcess[i].options.length > 0) {
      for (let j = 0; j < toProcess[i].options.length; j++) {
        toProcess[i].options[j] =
          typeof toProcess[i].options[j] === 'string'
            ? toProcess[i].options[j]
            : {
                ...toProcess[i].options[j],
                id: undefined,
              }
        updateQuestionVisibility(idMap, toProcess[i].options[j].shows_questions)
        updateQuestionVisibility(idMap, toProcess[i].options[j].hides_questions)
      }
    }
  }
  return toProcess
}

export default processQuestionnaire
